// src/features/auth/api/authApi.ts
import { axiosInstance } from '@/shared/api/axiosInstance';

export const getProfile = async () => {
    const res = await axiosInstance.get('/auth/me');
    return res.data;
};
